import {
  Container,
} from "../styled";
import FormConsultation from "../../../../../Forms/Consultation";

const LargeForm = () => {

  return (
    <>
      <Container>
        <FormConsultation variant="large" />
      </Container>
    </>
  );
};

export default LargeForm;
